module.exports = __webpack_public_path__ + "img/solution-v2x-system-pic-03.3be13c53.png";